[
  "a-session",
  "a-verify",
  "a-verifyexp",
  "a-signup",
  "a-signin",
  "a-mfa",
  "a-forgot",
  "a-reset",
  "a-resetnew",
  "a-orgblocked",
  "a-mfaenrol",
  "a-changepw",
  "a-invite",
  "a-confirm",
  "a-resendconfirm",
  "a-invitedead",
  "a-finishreg",
  "m-stepup",
  "m-runok",
  "m-rpoint",
  "m-cancelrestore",
  "m-cancel",
  "m-optgap",
  "m-invite",
  "m-mfareset",
  "ob-wz-1",
  "ob-wz-2",
  "ob-wz-3",
  "ob-wz-4",
  "ob-wz-5",
  "ob-wz-6",
  "v-home",
  "v-dashboard",
  "v-backup",
  "v-jobs",
  "v-jobsbackup",
  "v-backupjob",
  "v-snapshots",
  "v-jobsrestore",
  "v-restorejob",
  "v-restore",
  "access-wz-1",
  "access-wz-2",
  "access-wz-3",
  "access-wz-4",
  "access-wz-5",
  "ci-wz-1",
  "ci-wz-2",
  "ci-wz-3",
  "ci-wz-4",
  "ci-wz-5",
  "project-wz-1",
  "project-wz-2",
  "project-wz-3",
  "project-wz-4",
  "project-wz-5",
  "ref-wz-1",
  "ref-wz-2",
  "ref-wz-3",
  "ref-wz-4",
  "ref-wz-5",
  "ref-wz-6",
  "repo-wz-1",
  "repo-wz-2",
  "repo-wz-3",
  "repo-wz-4",
  "repo-wz-5",
  "review-wz-1",
  "review-wz-2",
  "review-wz-3",
  "review-wz-4",
  "review-wz-5",
  "settings-wz-1",
  "settings-wz-2",
  "settings-wz-3",
  "settings-wz-4",
  "settings-wz-5",
  "wshook-wz-1",
  "wshook-wz-2",
  "wshook-wz-3",
  "wshook-wz-4",
  "v-drift",
  "v-setbackup",
  "v-setgeneral",
  "v-setrepos",
  "v-connected",
  "v-notify",
  "v-health",
  "v-access",
  "v-branch",
  "v-dormant",
  "v-cicost",
  "v-waste",
  "v-storage",
  "v-filetypes",
  "v-seats",
  "v-radmins",
  "v-runused",
  "v-rnoappr",
  "v-rforce",
  "v-rdefdel",
  "v-rnopipe",
  "v-rflaky",
  "v-rgrowth",
  "v-rbigdl",
  "v-rbigfiles",
  "v-rbinary",
  "v-radminidle",
  "v-rnoauthor",
  "v-audit",
  "v-auditbb",
  "v-auditprod",
  "v-firstbackup",
  "v-users",
  "v-credential",
  "v-pending",
  "v-remap",
  "v-alerts",
  "v-lostcommits",
  "v-notprotected",
  "v-blocked",
  "v-section",
  "v-soon"
]
